import { render, staticRenderFns } from "./Dispositivo.vue?vue&type=template&id=6190bba4&"
import script from "./Dispositivo.vue?vue&type=script&lang=ts&"
export * from "./Dispositivo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports